import React from "react";
import {
  FaArrowLeft,
  FaSearch,
  FaSlidersH,
  FaHeart,
  FaBell,
  FaRegImage,
} from "react-icons/fa";

type StorePreviewProps = {
  themeColor: string;
  vendorName: string;
  logoUrl: string;
};

const StorePreviewPage: React.FC<StorePreviewProps> = ({
  themeColor,
  vendorName,
  logoUrl,
}) => {
  return (
    <div className="flex justify-center  py-2">
      <div className="w-[90vw] max-w-[375px] h-[160vw] max-h-[667px] bg-white rounded-2xl border border-gray-200 overflow-hidden">
        <div
          className="w-full p-4 rounded-t-2xl"
          style={{ backgroundColor: themeColor || "#FFFFFF" }}
        >
          <div className="flex items-center justify-between px-4 py-3">
            <button className="text-white" disabled>
              <FaArrowLeft size={20} />
            </button>
            <div className="flex space-x-4">
              <button disabled>
                <FaHeart size={20} className="text-white" />
              </button>
              <button disabled>
                <FaBell size={20} className="text-white" />
              </button>
            </div>
          </div>
          <div className="flex items-center m-4">
            <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-14 md:h-14 lg:w-18 lg:h-18 rounded-md flex-shrink-0">
              <img
                src={logoUrl}
                alt="Store Logo"
                className="h-full w-full bg-white object-contain border border-gray-300 rounded-lg"
              />
            </div>
            <div className="ml-4">
              <p className="font-semibold text-white text-lg">
                Welcome {vendorName}
              </p>
              <p className="text-sm text-white">Delivery by 5:45am — 0.5 mi</p>
            </div>
          </div>
          <div className="bg-white rounded-md mx-4 px-3 py-2 flex items-center space-x-2">
            <FaSearch className="text-gray-500" />
            <input
              type="text"
              placeholder="Search Products and categories"
              className="flex-1 text-gray-800 focus:outline-none"
              disabled
            />
            <button className="cursor-not-allowed" disabled>
              <FaSlidersH className="text-gray-500" />
            </button>
          </div>
          <div className="flex justify-between px-4 mt-3">
            {["All", "Category 1", "Category 2", "Category 3"].map((tab) => (
              <button
                key={tab}
                className="px-4 text-white font-semibold text-nowrap"
                disabled
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
        <div className="px-4 mt-4">
          <div className="flex justify-between items-center">
            <h2 className="font-semibold text-lg">Category 1</h2>
            <p className="text-gray-400 text-sm mb-3">View all (40+)</p>
          </div>
          <div className="overflow-x-auto">
            <div className="flex gap-2 justify-between">
              <div className="min-w-[150px] max-w-[150px] border rounded-lg p-3 bg-white flex-shrink-0">
                <div className="h-24 rounded-md flex items-center justify-center bg-gray-300">
                  <FaRegImage className="text-white" size={100} />
                </div>
                <p className="text-sm text-gray-800 mt-2 font-semibold">
                  Item 1 will be shown like this
                </p>
                <div className="flex justify-between items-center mt-1">
                  <p className="text-gray-400 font-bold">$5.79</p>
                  <p className="text-red-500 line-through">$8.78</p>
                </div>
                <p className="text-gray-400 text-xs">$0.11/fl oz</p>
                <p className="text-green-500 text-sm mt-1">Many in stock</p>
              </div>
              <div className="min-w-[15px] max-w-[150px] border rounded-lg p-3 bg-white flex-shrink-0">
                <div className="h-24 rounded-md flex items-center justify-center bg-gray-300">
                  <FaRegImage className="text-white" size={100} />
                </div>
                <p className="text-sm text-gray-800 mt-2 font-semibold">
                  Item 2 will be shown like this
                </p>
                <div className="flex justify-between items-center mt-1">
                  <p className="text-gray-400 font-bold">$4.29</p>
                  <p className="text-red-500 line-through">$6.78</p>
                </div>
                <p className="text-gray-400 text-xs">$0.07/fl oz</p>
                <p className="text-green-500 text-sm mt-1">Many in stock</p>
              </div>
              <div className="min-w-[150px] max-w-[150px] border rounded-lg p-3 bg-white flex-shrink-0">
                <div className="h-24 rounded-md flex items-center justify-center bg-gray-300">
                  <FaRegImage className="text-white" size={100} />
                </div>
                <p className="text-sm text-gray-800 mt-2 font-semibold">
                  Item 3 will be shown like this
                </p>
                <div className="flex justify-between items-center mt-1">
                  <p className="text-gray-400 font-bold">$3.99</p>
                  <p className="text-red-500 line-through">$5.99</p>
                </div>
                <p className="text-gray-400 text-xs">$0.10/fl oz</p>
                <p className="text-green-500 text-sm mt-1">In stock</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorePreviewPage;
